/* Fransk katalog for locale-autopilot-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'ap.review.completed': 'Contrôlé / approuvé',
  'ap.review.reviewApproved': 'Contrôle approuvé',
  'ap.review.approvedNotBooked': 'Approuvé · en attente de comptabilisation',
  'ap.review.booked': 'Comptabilisé',
  'ap.review.checked': 'Contrôlé',
  'ap.review.queueError': 'La file des tâches n\'a pas pu être actualisée. L\'aperçu est peut-être incomplet. Réessayez avant de traiter des propositions.',
  'ap.review.retry': 'Réessayer',
  'ap.review.overduePeriods': '{{count}} échéances sont dépassées',
  'ap.review.overduePeriod': '1 échéance est dépassée',
  'ap.review.overdueDetails': 'Points de suivi en retard : {{count}}. Dépôt : {{submissions}}. Paiement : {{payments}}.',
  'ap.review.deadlinePoints': '{{overdue}} points de suivi en retard et {{upcoming}} à venir',
  'ap.review.missingStatements': 'Relevés bancaires manquants',
  'ap.review.missingStatementsPeriod': 'Il manque le relevé bancaire de {{period}} pour ces comptes.',
  'ap.monthControl.liveTitle': 'Mois en cours',
  'ap.monthControl.liveBlockedReason': 'Le mois est en cours. Vous pouvez traiter et approuver les lignes au fil de l\'eau, mais la finalisation sera disponible après la fin du mois.',
  'ap.cancelEntry': 'Annuler l\'écriture',
  'ap.saveEntry': 'Enregistrer l\'écriture',
  'ap.suggestion': 'Suggestion de SuperPlumma',
  'ap.amountIncVat': 'Montant (TVA incl.)',
  'ap.saveCorrection': 'Enregistrer la correction',
  'ap.correct': 'Corriger',
  'ap.openInPayroll': 'Ouvrir dans la paie',
  'ap.payrollLines': 'Lignes de paie',
  'ap.hoursCount': 'Nombre d\'heures',
  'ap.hourlyRate': 'Taux horaire',
  'ap.monthlyGross': 'Salaire mensuel (brut)',
  'ap.holidayPayAccrued': 'Indemnité de congés payés provisionnée (12 %)',
  'ap.employerCosts': 'Coûts employeur',
  'ap.employerContribution': 'Cotisations patronales (14,1 %)',
  'ap.mandatoryPension': 'Retraite professionnelle obligatoire (2 %)',
  'ap.approveAndFile': 'Approuver et déposer',
  'ap.vatReturnTitle': 'MVA-melding (déclaration de TVA)',
  'ap.post': 'Poste',
  'ap.checkPost': 'Contrôler le poste',
  'ap.allPostsChecked': 'Tous les postes ont été contrôlés.',
  'ap.registerAsset': 'Enregistrer un actif',
  'ap.backToAssets': 'Retour aux actifs',
  'ap.confirmAsset': 'Confirmer l\'actif',
  'ap.registeredAutomatically': 'Enregistré automatiquement',
  'ap.balanceGroup': 'Groupe de solde',
  'ap.amountExVat': 'Montant (HT)',
  'ap.registeredFrom': 'Enregistré depuis',
  'ap.registeredAssets': 'Actifs enregistrés',
  'ap.approveRegistrations': 'Approuver les enregistrements',
  'ap.saveAllAndApprove': 'Tout enregistrer et approuver',
  'ap.skip': 'Ignorer',
  'ap.skipped': 'Ignoré',
  'ap.amountIncVatShort': 'Montant TVA incl.',
  'ap.openVoucherFull': 'Ouvrir le justificatif en taille réelle',
  'ap.security': 'Sécurité',
  'ap.dragVoucherHere': 'Faites glisser un justificatif de la boîte de réception ici',
  'ap.approve': 'Approuver',
  'ap.dragVoucherOntoLine': 'Faites glisser un justificatif sur la ligne à laquelle vous voulez le lier.',
  'ap.approveTask': 'Approuver la tâche',
  'ap.sent': 'Envoyé',
  'ap.sentCount': '{{count}} envoyé(s)',
  'ap.openVatReturn': 'Ouvrir la MVA-melding',
  'ap.openTask': 'Ouvrir la tâche',
  'ap.reopenTask': 'Annuler l\'approbation',
  'ap.rerun': 'Revoir à nouveau',
  'ap.rerunHelp': 'Recharge la file depuis Functions et reconstruit la liste de l\'agent. Rien n\'est comptabilisé ni approuvé.',
  'ap.rerunDone': 'AI Comptable a revu {{month}} à nouveau.',
  'ap.rerunFailed': 'Impossible de relancer la revue.',
  'ap.staleApproval': 'Approuvé le {{date}} · la base a changé depuis',
  'ap.bankConnection': 'Connexion bancaire',
  'ap.agent.invoice.title': '{{count}} facture(s) non envoyée(s)',
  'ap.agent.invoice.titleDone': 'Toutes les factures ont été envoyées',
  'ap.agent.invoice.desc': '{{drafts}} sont en brouillon et {{unsent}} sont terminées mais non envoyées.',
  'ap.agent.invoice.descDone': 'Aucun brouillon ni facture non envoyée en {{year}}.',
  'ap.agent.invoice.detail': 'Un brouillon n\'est ni constaté en produit ni envoyé au client. L\'envoi et la comptabilisation se font depuis la liste des factures.',
  'ap.agent.invoice.action': 'Ouvrir la liste des factures',
  'ap.agent.invoice.lineDraft': 'Brouillon · non constaté en produit',
  'ap.agent.invoice.lineUnsent': 'Terminée, mais non envoyée',
  'ap.agent.invoice.execute': 'Envoyer {{count}} factures',
  'ap.agent.invoice.choose': 'Sélectionner des factures',
  'ap.agent.invoice.selectAll': 'Sélectionner toutes celles pouvant être envoyées',
  'ap.agent.invoice.selectRow': 'Sélectionner la facture',
  'ap.agent.invoice.selectedCount': '{{count}} sélectionnée(s)',
  'ap.agent.invoice.sendableCount': '{{count}} peuvent être envoyées',
  'ap.agent.invoice.finishDraftFirst': 'Les brouillons doivent être finalisés avant de pouvoir être envoyés',
  'ap.agent.invoice.sendSelectedOne': 'Envoyer la facture sélectionnée',
  'ap.agent.invoice.sendSelected': 'Envoyer les {{count}} factures sélectionnées',
  'ap.agent.invoice.executeDone': 'factures envoyées',
  'ap.agent.dunning.title': '{{count}} facture(s) échue(s) en attente de relance',
  'ap.agent.dunning.titleDone': 'Aucune facture échue',
  'ap.agent.dunning.desc': '{{amount}} kr restent impayés après échéance.',
  'ap.agent.dunning.descDone': 'Toutes les factures envoyées sont dans les délais ou payées.',
  'ap.agent.dunning.detail': 'Les relances, frais de relance et intérêts de retard sont envoyés depuis la liste des factures. AI Comptable n\'envoie rien de lui-même.',
  'ap.agent.dunning.action': 'Ouvrir la liste des factures',
  'ap.agent.dunning.line': 'Échue depuis {{days}} jour(s) · facture {{num}}',
  'ap.agent.dunning.execute': 'Envoyer {{count}} rappels',
  'ap.agent.dunning.executeTitle': 'Envoyer des rappels de paiement',
  'ap.agent.dunning.executeWarn': 'Les rappels sont envoyés directement à vos clients et ne peuvent pas être annulés. Les clients qui viennent de payer sans que le paiement soit enregistré en recevront aussi un.',
  'ap.agent.dunning.executeNote': 'Plumme ne relance pas la même facture plus d\'une fois tous les sept jours et ignore les factures soldées ou sans e-mail client.',
  'ap.agent.dunning.executeDone': 'rappels envoyés',
  'ap.agent.inbox.title': '{{count}} justificatif(s) de la boîte de réception non comptabilisé(s)',
  'ap.agent.inbox.titleDone': 'La boîte de réception est vide',
  'ap.agent.inbox.desc': '{{ready}} sont prêts à être comptabilisés et {{review}} doivent être contrôlés.',
  'ap.agent.inbox.descAnalyzing': '{{count}} justificatif(s) en cours de lecture.',
  'ap.agent.inbox.descDone': 'Aucun justificatif en attente de traitement.',
  'ap.agent.inbox.detail': 'Les justificatifs sont lus automatiquement à leur arrivée. La comptabilisation et le choix des comptes sont approuvés dans la boîte de réception.',
  'ap.agent.inbox.action': 'Ouvrir la boîte de réception',
  'ap.agent.inbox.execute': 'Comptabiliser {{count}} justificatifs prêts',
  'ap.agent.inbox.executeDone': 'justificatifs comptabilisés',
  'ap.agent.inbox.voucher': 'Justificatif',
  'ap.agent.inbox.lineReady': 'Lu et prêt à être comptabilisé',
  'ap.agent.inbox.lineReview': 'À contrôler avant comptabilisation',
  'ap.agent.reconcile.title': '{{count}} mois non rapproché(s)',
  'ap.agent.reconcile.titleDone': 'Tous les mois clôturés sont rapprochés',
  'ap.agent.reconcile.descEarly': 'Aucun mois n\'est encore clôturé en {{year}}.',
  'ap.agent.reconcile.desc': '{{closed}} sur {{total}} mois clôturés sont rapprochés et comptabilisés.',
  'ap.agent.reconcile.descDone': 'Le compte bancaire professionnel est rapproché jusqu\'au mois dernier inclus.',
  'ap.agent.reconcile.detail': 'Un mois est considéré comme rapproché lorsque le relevé du compte professionnel est comptabilisé et archivé dans Banque. Le rapprochement doit se faire dans l\'ordre chronologique.',
  'ap.agent.reconcile.action': 'Ouvrir la banque',
  'ap.agent.reconcile.titleBlockedOrder': '{{month}} doit être rapproché d\'abord',
  'ap.agent.reconcile.descBlockedOrder': 'Le rapprochement suit l\'ordre chronologique. Le solde d\'ouverture provient du mois précédent, un écart à ce niveau passerait donc inaperçu ici.',
  'ap.agent.reconcile.detailBlockedOrder': 'Allez dans Banque et terminez la plus ancienne période non rapprochée. Ce mois se débloquera alors de lui-même.',
  'ap.agent.reconcile.reasonBlockedOrder': 'En attente de {{month}}',
  'ap.agent.reconcile.line': 'Aucun relevé professionnel rapproché',
  'ap.agent.quality.title': '{{count}} constat(s) du contrôle qualité',
  'ap.agent.quality.titleDone': 'Aucun constat du contrôle qualité',
  'ap.agent.quality.desc': '{{missing}} achat(s) sans justificatif et {{duplicates}} peut-être comptabilisé(s) deux fois.',
  'ap.agent.quality.descDone': 'Tous les achats de {{year}} ont un justificatif et aucun doublon possible n\'a été trouvé.',
  'ap.agent.quality.detailVat': 'Les achats sans justificatif représentent {{vat}} kr de TVA déductible qui pourrait être rejetée lors d\'un contrôle.',
  'ap.agent.quality.detail': 'Les doublons possibles sont des achats avec le même fournisseur, le même montant et la même date. Ils doivent être évalués manuellement avant toute annulation.',
  'ap.agent.quality.action': 'Ouvrir les transactions',
  'ap.agent.quality.purchase': 'Achat',
  'ap.agent.quality.lineDuplicate': '{{count}} écritures avec le même fournisseur, montant et date',
  'ap.agent.quality.lineMissing': 'Justificatif manquant · ouvrez l\'achat pour téléverser ou lier une pièce',
  'ap.agent.deadline.titleOverdue': '{{count}} échéance(s) dépassée(s)',
  'ap.agent.deadline.title': '{{count}} échéance(s) approche(nt)',
  'ap.agent.deadline.titleDone': 'Aucune échéance dans les 30 prochains jours',
  'ap.agent.deadline.desc': 'La prochaine échéance est {{name}} {{date}}.',
  'ap.agent.deadline.descOverdue': '{{count}} déclaration(s) en retard non régularisée(s).',
  'ap.agent.deadline.descDone': 'Toutes les déclarations dues dans les 30 jours ont été déposées.',
  'ap.agent.deadline.lineNotFiled': 'En retard · non déposée',
  'ap.agent.deadline.lineNotPaid': 'En retard · non marquée comme payée',
  'ap.agent.deadline.detail': 'Les échéances dépendent de la période de TVA et de la forme juridique de l\'entreprise. Le dépôt se fait depuis Déclarations.',
  'ap.agent.deadline.action': 'Ouvrir les déclarations',
  'ap.agent.deadline.lineOverdue': 'En retard de {{days}} jour(s)',
  'ap.agent.deadline.line': '{{days}} jour(s) restant(s)',
  'ap.agent.annualDeadline.subjectMany': '{{count}} déclarations',
  'ap.agent.annualDeadline.titleDone': 'Les échéances de {{month}} sont réglées',
  'ap.agent.annualDeadline.titleOverdue': '{{subject}} n\'a pas été déposé — l\'échéance est dépassée',
  'ap.agent.annualDeadline.title': '{{subject}} est à déposer en {{month}}',
  'ap.agent.annualDeadline.desc': '{{name}} pour {{year}} est à déposer le {{date}}.',
  'ap.agent.annualDeadline.descDone': 'Toutes les déclarations dues en {{month}} sont marquées comme déposées.',
  'ap.agent.annualDeadline.detail': 'L\'échéance tombe l\'année suivant l\'exercice fiscal : cela concerne donc les comptes {{year}} — et non {{calendarYear}}. Cette ligne ne bloque pas la validation du mois.',
  'ap.agent.annualDeadline.action': 'Ouvrir',
  'ap.agent.annualDeadline.lineFiled': 'Marquée comme déposée',
  'ap.agent.annualDeadline.execute': 'Marquer comme déposée hors de Plumme',
  'ap.agent.annualDeadline.executeTitle': 'Marquer l\'aksjonærregisteroppgave comme déposée',
  'ap.agent.annualDeadline.executeWarn': 'Plumme n\'envoie rien. Cela enregistre seulement que la déclaration a été déposée ailleurs, afin que l\'échéance cesse d\'alerter.',
  'ap.agent.annualDeadline.executeNote': 'L\'aksjonærregisteroppgave (RF-1086) est déposée depuis un logiciel utilisateur ou Altinn. Les sociétés de logement sont exemptées, et les sociétés pour lesquelles Euronext VPS dépose ne doivent pas déposer elles-mêmes.',
  'ap.agent.annualDeadline.executeDone': 'marquée',
  'ap.agent.annualDeadline.statusDetail': '{{subject}} doit être traité dans le flux de clôture annuelle.',
  'ap.agent.mileage.title': '{{count}} trajet(s) du journal de bord kilométrique sans justificatif',
  'ap.agent.mileage.titleOk': '{{count}} trajet(s) du journal de bord kilométrique documenté(s)',
  'ap.agent.mileage.titleEmpty': 'Aucun trajet enregistré en {{year}}',
  'ap.agent.mileage.desc': 'Le journal de bord kilométrique donne {{amount}} kr de déduction en {{year}}.',
  'ap.agent.mileage.descEmpty': 'Les déplacements professionnels sont déductibles, mais seulement si chaque trajet indique la date, l\'itinéraire, l\'objet et les kilomètres.',
  'ap.agent.mileage.detail': 'Un journal de bord kilométrique doit indiquer pour chaque trajet la date, le départ et l\'arrivée, l\'objet et le nombre de kilomètres. Les trajets incomplets peuvent être rejetés.',
  'ap.agent.mileage.action': 'Ouvrir le journal de bord',
  'ap.agent.mileage.trip': 'Trajet sans itinéraire',
  'ap.agent.mileage.lineNoPurpose': 'Objet manquant',
  'ap.agent.mileage.lineNoKm': 'Kilomètres manquants',
  'ap.agent.mileage.lineNoRoute': 'Itinéraire manquant',
  'ap.agent.match.title': '{{count}} lignes bancaires sans justificatif',
  'ap.agent.match.titleDone': 'Toutes les lignes bancaires ont un justificatif',
  'ap.agent.match.desc': '{{count}} justificatifs de la boîte de réception pourraient correspondre.',
  'ap.agent.match.descDone': 'Aucune ligne bancaire sans justificatif.',
  'ap.agent.match.detail': 'Un justificatif n\'est rapproché automatiquement que s\'il correspond à une seule ligne bancaire et que cette ligne correspond à un seul justificatif. En cas de doute, vous choisissez.',
  'ap.agent.match.action': 'Ouvrir la banque',
  'ap.agent.match.line': 'Justificatif manquant',
  'ap.agent.match.execute': 'Rapprocher les justificatifs automatiquement',
  'ap.agent.match.executeTitle': 'Rapprocher les justificatifs des lignes bancaires',
  'ap.agent.match.executeWarn': 'Les justificatifs sont joints comme pièces aux lignes bancaires. Rien n\'est comptabilisé — cela se fait lors du rapprochement du relevé.',
  'ap.agent.match.executeNote': 'Seules les correspondances univoques sont rapprochées : le justificatif doit correspondre à une ligne bancaire, et la ligne à un justificatif. Le reste attend une sélection manuelle.',
  'ap.agent.match.executeDone': 'justificatifs rapprochés',
  'ap.agent.contacts.supplier': 'fournisseurs',
  'ap.agent.contacts.customer': 'clients',
  'ap.agent.contacts.title': 'Jusqu\'à {{count}} {{noun}} manquent dans le registre',
  'ap.agent.contacts.titleDone': 'Tous les {{noun}} sont enregistrés',
  'ap.agent.contacts.desc': 'Noms récurrents dans la comptabilité mais absents du registre.',
  'ap.agent.contacts.descDone': 'Aucun nom récurrent hors du registre.',
  'ap.agent.contacts.detail': 'Seuls le nom et le numéro d\'organisation sont créés. L\'e-mail, le téléphone et l\'adresse sont à compléter par vous — Plumme ne devine pas des coordonnées qui pourraient figurer sur une facture.',
  'ap.agent.contacts.openSuppliers': 'Ouvrir les fournisseurs',
  'ap.agent.contacts.openCustomers': 'Ouvrir les clients',
  'ap.agent.contacts.line': '{{count}} écritures',
  'ap.agent.contacts.execute': 'Créer les {{noun}} manquants',
  'ap.agent.contacts.executeTitle': 'Créer les {{noun}} dans le registre',
  'ap.agent.contacts.executeWarn': 'Les noms sont créés dans le registre. Les écritures existantes ne sont pas liées automatiquement — vous le faites en ouvrant l\'écriture.',
  'ap.agent.contacts.executeNote': 'Plumme ne crée que les noms qui reviennent au moins deux fois et ignore les libellés de paiement comme « Visa » et « Vipps ».',
  'ap.agent.contacts.executeDone': 'créés',
  'ap.contact.supplierNumber': 'N° fournisseur',
  'ap.contact.supplierNumberPh': 'Ex. 20001',
  'ap.contact.supplierName': 'Nom du fournisseur',
  'ap.contact.customerName': 'Nom du client',
  'ap.contact.namePh': 'Nom',
  'ap.contact.customerNamePh': 'Ex. Exemple AS',
  'ap.contact.org': 'N° d\'organisation',
  'ap.contact.orgOptional': 'N° d\'organisation (facultatif)',
  'ap.contact.orgPh': '123 456 789',
  'ap.contact.supplierEmailPh': 'faktura@leverandor.no',
  'ap.contact.customerEmailPh': 'post@eksempel.no',
  'ap.contact.phonePh': '400 00 000',
  'ap.contact.address': 'Adresse',
  'ap.contact.addressPh': 'Adresse postale',
  'ap.contact.supplierAddressPh': 'Adresse, code postal et ville',
  'ap.agent.tax.titleBlocked': 'La base imposable n\'est pas disponible',
  'ap.agent.tax.descBlocked': 'Les chiffres comptables de {{year}} ne sont pas chargés.',
  'ap.agent.tax.detail': 'Le dépôt de la skattemelding nécessite l\'intégration Altinn, qui n\'est pas encore connectée.',
  'ap.agent.tax.blocked': 'Chiffres comptables manquants',
  'ap.agent.tax.titleDone': 'La skattemelding {{year}} a été déposée',
  'ap.agent.tax.title': 'La base imposable {{year}} est calculée',
  'ap.agent.tax.descEnk': 'Résultat avant impôt : {{result}} kr. Une entreprise individuelle est imposée au nom de son propriétaire.',
  'ap.agent.tax.desc': 'Un résultat avant impôt de {{result}} kr donne {{tax}} kr d\'impôt calculé.',
  'ap.agent.tax.action': 'Ouvrir la skattemelding',
  'ap.agent.tax.lineResult': 'Résultat avant impôt',
  'ap.agent.tax.lineTax': 'Impôt calculé',
  'ap.agent.tax.lineLoss': 'Déficit reportable',
  'ap.agent.annual.titleBlocked': 'Les comptes annuels ne sont pas disponibles',
  'ap.agent.annual.descBlocked': 'Les chiffres comptables de {{year}} ne sont pas chargés.',
  'ap.agent.annual.blocked': 'Chiffres comptables manquants',
  'ap.agent.annual.titleNotRequired': 'L\'entreprise n\'est pas tenue de déposer des comptes annuels',
  'ap.agent.annual.descNotRequired': 'Une entreprise individuelle dépose à la place la næringsspesifikasjon avec la skattemelding.',
  'ap.agent.annual.action': 'Ouvrir les comptes annuels',
  'ap.agent.annual.stepDocument': 'Document des comptes annuels',
  'ap.agent.annual.stepBoard': 'Procès-verbal du conseil',
  'ap.agent.annual.stepAssembly': 'Procès-verbal de l\'assemblée générale',
  'ap.agent.annual.stepSigned': 'Signature',
  'ap.agent.annual.titleDone': 'Les comptes annuels {{year}} ont été déposés',
  'ap.agent.annual.title': '{{count}} étapes restantes dans les comptes annuels {{year}}',
  'ap.agent.annual.titleReady': 'Les comptes annuels {{year}} sont prêts à être déposés',
  'ap.agent.annual.descClosed': 'L\'exercice est clôturé.',
  'ap.agent.annual.descOpen': 'L\'exercice n\'est pas encore clôturé.',
  'ap.agent.annual.detail': 'Le dépôt au Regnskapsregisteret nécessite l\'intégration Altinn, qui n\'est pas encore connectée.',
  'ap.agent.annual.line': 'Non terminé',
  'ap.execute.title': 'Comptabiliser depuis AI Comptable',
  'ap.execute.running': 'Comptabilisation …',
  'ap.execute.warnTitleGeneric': 'Cette action est irréversible',
  'ap.execute.warnTitle': 'Cette action comptabilise dans vos comptes',
  'ap.execute.warnBody': 'Les justificatifs sont comptabilisés comme achats avec le compte, la TVA et le mode de paiement issus de l\'analyse des justificatifs. Vous êtes responsable de l\'exactitude des écritures et devez les annuler manuellement en cas d\'erreur.',
  'ap.execute.checked': 'Plumme vérifie à nouveau chaque justificatif avant de le comptabiliser. Les justificatifs non conformes restent dans la boîte de réception avec un motif.',
  'ap.execute.doneCount': '{{booked}} {{noun}}',
  'ap.execute.done': '{{booked}} justificatifs comptabilisés',
  'ap.execute.partialCount': '{{done}} {{skipped}} n\'ont pas été traités et nécessitent un suivi.',
  'ap.execute.failed': 'La comptabilisation n\'a pas abouti.',
  'ap.lastRun': 'Dernière revue {{when}}',
  'ap.lastRunLabel': 'Dernière revue',
  'ap.bankDataHelp': 'SuperPlumma utilise les relevés bancaires que vous avez importés sous Banque. La connexion bancaire directe n\'existe pas encore – importez un relevé au format XLSX ou CSV pour intégrer les lignes bancaires.',
  'ap.bankData': 'Données bancaires',
  'ap.bankStatementImported': 'Relevé bancaire importé',
  'ap.noBankData': 'Aucun relevé bancaire importé',
  'ap.noData': 'Aucune donnée',
  'ap.importBankStatement': 'Importer un relevé bancaire',
  'ap.loadingTitle': 'Chargement de votre comptabilité …',
  'ap.loadingText': 'SuperPlumma attend les données de votre comptabilité. La liste des tâches s\'affiche dès que les chiffres sont chargés.',
  'ap.disconnectBank': 'Déconnecter la banque',
  'ap.connected': 'Connecté',
  'ap.noBankConnected': 'Aucune banque connectée',
  'ap.connectBankHelp': 'Connectez votre banque pour que SuperPlumma puisse comptabiliser les transactions bancaires.',
  'ap.bankIdNote': 'La connexion se fait en toute sécurité avec BankID.',
  'ap.missingBasis': 'Base manquante',
  'ap.rowDescMissing': 'Des informations manquent avant qu\'AI Comptable puisse poursuivre.',
  'ap.rowBlockedReasonDefault': 'Nécessite une configuration ou des données',
  'ap.rowOpen': 'Ouvrir',
  'ap.working': 'Traitement …',
  'ap.execute.queued': 'Mis en file d\'attente. S\'exécute même si vous fermez la page – vous serez averti à la fin.',
  'ap.execute.queueFailed': 'Impossible de mettre l\'action en file d\'attente.',
  'ap.job.done': '{{booked}} effectué(s).',
  'ap.job.donePartial': '{{booked}} effectué(s) · {{skipped}} n\'ont pas été traités et nécessitent un suivi.',
  'ap.job.failed': 'L\'action n\'a pas abouti.',
  'ap.waiting': 'En attente',
  'ap.waitingDetail': 'Ne peut pas encore être traité',
  'ap.waitingGroup.title': '{{count}} agents en attente',
  'ap.waitingGroup.titleOne': '{{agent}} en attente',
  'ap.waitingGroup.detail': 'Deviennent pertinents lorsque la période est prête',
  'ap.oneLineNeedsControl': ' ligne à vérifier',
  'ap.manyLinesNeedControl': ' lignes à vérifier',
  'ap.readyHere': '{{count}} prêt(s)',
  'ap.openWorklist': 'Ouvrir la liste de travail',
  'ap.controlWorklist': 'Vérifier la liste de travail',
  'ap.controlTask': 'Vérifier',
  'ap.openPage': 'Ouvrir la page',
  'ap.waitsForPrevious': 'En attente',
  'ap.nextStep': 'Étape suivante',
  'ap.comeBackLater': 'Revenez plus tard',
  'ap.solveBlocker': 'Lever le blocage',
  'ap.getBankData': 'Récupérer les données bancaires',
  'ap.approved': 'Approuvé',
  'ap.whichAgents': 'Quels agents souhaitez-vous activer ?',
  'ap.allAgents': 'Tous les agents',
  'ap.settings.enabledCount': '{{on}} sur {{total}} activés',
  'ap.settings.intro': 'SuperPlumma et les agents travaillent en continu sur votre comptabilité. Choisissez les agents qui doivent vous aider. Vous pouvez modifier ces paramètres à tout moment. Les tâches non activées doivent être effectuées manuellement par vous-même.',
  'ap.settings.allHelp': 'Activer ou désactiver tous les agents en une fois.',
  'ap.permission.inbox.label': 'Agent boîte de réception',
  'ap.permission.inbox.desc': 'Lit les reçus et factures reçus par e-mail ou téléversement, et les prépare pour la comptabilisation.',
  'ap.permission.matching.label': 'Agent justificatifs',
  'ap.permission.matching.desc': 'Rapproche les justificatifs de la boîte de réception des lignes bancaires sans pièce, lorsque la correspondance est univoque.',
  'ap.permission.reconciliation.label': 'Agent rapprochement',
  'ap.permission.reconciliation.desc': 'Veille à ce que chaque mois clôturé soit effectivement rapproché et comptabilisé avec le compte bancaire d\'exploitation.',
  'ap.permission.control.label': 'Agent contrôle',
  'ap.permission.control.desc': 'Recherche les achats sans justificatif et les doublons possibles dans la comptabilité.',
  'ap.permission.asset.label': 'Agent immobilisations',
  'ap.permission.asset.desc': 'Propose une immobilisation pour les achats importants. Vous choisissez la passation en charges ou le groupe d\'amortissement avant que le justificatif ne soit comptabilisé une seule fois.',
  'ap.permission.vendor.label': 'Agent fournisseurs',
  'ap.permission.vendor.desc': 'Crée de nouveaux fournisseurs lorsque SuperPlumma détecte des écritures répétées d\'un même fournisseur.',
  'ap.permission.customer.label': 'Agent clients',
  'ap.permission.customer.desc': 'Crée de nouveaux clients lorsque SuperPlumma détecte des ventes à des clients inconnus.',
  'ap.permission.invoice.label': 'Agent factures',
  'ap.permission.invoice.desc': 'Assure le suivi des brouillons de factures et des factures finalisées non envoyées au client.',
  'ap.permission.dunning.label': 'Agent relances',
  'ap.permission.dunning.desc': 'Suit les factures échues et indique lesquelles relancer en priorité.',
  'ap.permission.deadline.label': 'Agent échéances',
  'ap.permission.deadline.desc': 'Avertit des dates limites de dépôt proches ou dépassées.',
  'ap.permission.mileage.label': 'Agent journal kilométrique',
  'ap.permission.mileage.desc': 'Vérifie que les trajets professionnels sont saisis avec l\'itinéraire, le motif et les kilomètres, afin que la déduction soit justifiée.',
  'ap.permission.vat.label': 'Agent TVA',
  'ap.permission.vat.desc': 'Rapproche la TVA et prépare la MVA-melding pour le dépôt.',
  'ap.permission.tax.label': 'Agent fiscal',
  'ap.permission.tax.desc': 'Pré-remplit la skattemelding à partir de votre comptabilité.',
  'ap.permission.payroll.label': 'Agent paie',
  'ap.permission.payroll.desc': 'Suit les traitements de paie en attente d\'approbation. Le calcul et l\'approbation se font dans l\'espace Paie.',
  'ap.permission.annual.label': 'Agent comptes annuels',
  'ap.permission.annual.desc': 'Prépare les comptes annuels et les notes lors de la clôture annuelle.',
  'ap.beta': 'Bêta',
  'ap.heroTitle': 'SuperPlumma fait le travail – vous gardez le contrôle.',
  'ap.heroSub': 'Voyez ce qui reste à faire, vérifiez les propositions et approuvez l\'étape suivante.',
  'ap.aboutHelp': 'SuperPlumma regroupe les tâches et prépare des propositions à partir des données disponibles. La comptabilisation et l\'envoi nécessitent votre approbation. L\'interrupteur contrôle la revue automatique, pas le dépôt ni le paiement.',
  'ap.enabledDescription': 'SuperPlumma passe en revue votre comptabilité chaque matin et regroupe ce qui est en attente. Choisissez les domaines que les agents doivent examiner. Rien n\'est comptabilisé ni envoyé sans votre approbation.',
  'ap.disabledDescription': 'Le pilote automatique est désactivé. Activez-le pour que SuperPlumma examine votre comptabilité en arrière-plan.',
  'ap.monthOpenHelp': 'SuperPlumma prépare des propositions tout au long du mois. Certaines étapes attendent que la période soit prête, mais tout se met à jour automatiquement à l\'arrivée de nouvelles données.',
  'ap.monthControl.label': 'Contrôle mensuel',
  'ap.monthControl.permissionDesc': 'Traite les lignes bancaires, justificatifs, tiers et immobilisations possibles, et rapproche le mois dans un flux de travail unique.',
  'ap.monthControl.blockedDesc': 'Les données bancaires manquent. Les justificatifs sans ligne bancaire peuvent toujours être traités.',
  'ap.monthControl.actionableDesc': 'Points restants en {{period}} : {{count}}. Lignes bancaires, justificatifs, tiers, immobilisations et rapprochement sont traités ensemble.',
  'ap.monthControl.doneDesc': 'Le contrôle mensuel de {{period}} est terminé.',
  'ap.monthControl.title': 'Contrôle mensuel de **{{period}}**',
  'ap.monthControl.detail': 'Traitez les lignes bancaires dans l\'ordre chronologique, liez les justificatifs, créez les tiers manquants et examinez les immobilisations possibles dans le même espace de travail. L\'approbation est réversible ; la comptabilisation définitive se fait toujours avec « Rapprocher et comptabiliser ».',
  'ap.monthControl.waitingDetail': 'La période est en cours — de nouvelles lignes peuvent encore arriver',
  'ap.monthControl.blockedReason': 'Relevé bancaire ou couverture bancaire manquant',
  'ap.monthControl.action': 'Ouvrir le contrôle mensuel',
  'ap.monthControl.findingsEmpty': 'Aucun écart possible.',
  'ap.monthControl.finding.deviation': 'Écart possible',
  'ap.monthControl.finding.missingVoucher': 'Justificatif manquant',
  'ap.monthControl.finding.needsReview': 'À contrôler avant le rapprochement.',
  'ap.monthControl.count.inboxOne': '{{count}} justificatif dans la boîte de réception',
  'ap.monthControl.count.inboxMany': '{{count}} justificatifs dans la boîte de réception',
  'ap.monthControl.count.bankMissingVoucherOne': '{{count}} ligne bancaire sans justificatif',
  'ap.monthControl.count.bankMissingVoucherMany': '{{count}} lignes bancaires sans justificatif',
  'ap.monthControl.count.bankLineOne': '{{count}} ligne bancaire',
  'ap.monthControl.count.bankLineMany': '{{count}} lignes bancaires',
  'ap.monthControl.count.reconciliationOne': '{{count}} rapprochement',
  'ap.monthControl.count.reconciliationMany': '{{count}} rapprochements',
  'ap.monthControl.count.qualityOne': '{{count}} constat du contrôle qualité',
  'ap.monthControl.count.qualityMany': '{{count}} constats du contrôle qualité',
  'ap.monthControl.count.assetOne': '{{count}} actif',
  'ap.monthControl.count.assetMany': '{{count}} actifs',
  'ap.monthControl.count.supplierOne': '{{count}} fournisseur',
  'ap.monthControl.count.supplierMany': '{{count}} fournisseurs',
  'ap.monthControl.count.customerOne': '{{count}} client',
  'ap.monthControl.count.customerMany': '{{count}} clients',
  'ap.monthControl.count.itemOne': '{{count}} point',
  'ap.monthControl.count.itemMany': '{{count}} points',
  'ap.monthControl.noDate': 'Sans date',
  'ap.monthControl.action.paySupplierInvoice': 'Payer la facture fournisseur',
  'ap.monthControl.action.registerSupplierInvoice': 'Enregistrer la facture fournisseur',
  'ap.monthControl.action.invoicePayment': 'Paiement de facture',
  'ap.monthControl.action.registerSale': 'Enregistrer une vente',
  'ap.monthControl.action.registerPurchase': 'Enregistrer un achat',
  'ap.monthControl.block.needsControl': 'Le justificatif doit être contrôlé avant d’être comptabilisé.',
  'ap.monthControl.block.missingBookingType': 'Type de comptabilisation manquant.',
  'ap.monthControl.block.missingInvoiceNumber': 'Numéro de facture manquant.',
  'ap.monthControl.block.lowConfidence': 'Faible fiabilité de l’analyse.',
  'ap.monthControl.block.manualReview': 'Le justificatif nécessite un contrôle manuel.',
  'ap.monthControl.edit.purchase': 'Modifier l’achat',
  'ap.monthControl.edit.sale': 'Modifier la vente',
  'ap.monthControl.edit.bankFee': 'Modifier les frais',
  'ap.monthControl.edit.invoicePayment': 'Modifier le paiement de facture',
});
